import React from "react";
import Tooltip from "./Tooltip.styles";

export default React.memo(Tooltip);
